module.exports = __webpack_public_path__ + "static/media/container-h.3d7119bd.png";